import React from 'react';
import proptypes from 'prop-types';
const { func } = proptypes;
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { isFunction } from '../../../components/helper/utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';

export const NotLocalized = ({ customRender }) => {

  const openLocalizerPopup = (event) => {
    event.preventDefault();
    const myStoreButton = document.querySelector('#myStore .MyStore__button')
      // mw
      || document.querySelector('.MyStore__button.MyStore--inline__button');

    if (myStoreButton) {
      myStoreButton.click();
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  if (isFunction(customRender)) {
    return customRender({ pickUpTemplate: PICKUP_TEMPLATES.NO_STORE_OPTION, values: { } });
  }

  return (
    <div data-component="NotLocalized" className="sui-flex">
      <Typography variant="body-sm">
        {/* eslint-disable-next-line */}
        <Link
          underline="always"
          onClick={openLocalizerPopup}
        >Set your store
        </Link>
        <span> to see local availability</span>
      </Typography>
    </div>
  );

};

NotLocalized.propTypes = {
  customRender: func
};

NotLocalized.defaultProps = {
  customRender: null
};

NotLocalized.displayName = 'NotLocalized';
